import React from 'react';
import { useNavigate } from 'react-router-dom';
import { EyeIcon, TableCellsIcon, ChartBarIcon } from '@heroicons/react/24/outline';

const MarketingBudgetReports = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
              Budget Reports
            </h1>
            <p className="mt-2 text-gray-600 dark:text-gray-400">
              Marketing bütçe raporları ve analizler
            </p>
          </div>

        {/* Center Buttons - Grid Layout */}
        <div className="flex justify-center items-start min-h-[60vh] pt-8">
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 w-full max-w-7xl px-4">
            <button
              onClick={() => navigate('/marketing-budget/tables')}
              className="flex flex-col items-center justify-center px-3 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-all duration-200 shadow hover:shadow-md transform hover:scale-[1.02] aspect-[5/2]"
            >
              <TableCellsIcon className="h-5 w-5 mb-1" />
              <span className="text-xs font-semibold text-center leading-tight">Tables</span>
            </button>
            <button
              onClick={() => navigate('/marketing-budget/manager-view')}
              className="flex flex-col items-center justify-center px-3 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-all duration-200 shadow hover:shadow-md transform hover:scale-[1.02] aspect-[5/2]"
            >
              <EyeIcon className="h-5 w-5 mb-1" />
              <span className="text-xs font-semibold text-center leading-tight">Manager View</span>
            </button>
            <button
              onClick={() => navigate('/marketing-budget/analysis')}
              className="flex flex-col items-center justify-center px-3 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-all duration-200 shadow hover:shadow-md transform hover:scale-[1.02] aspect-[5/2]"
            >
              <ChartBarIcon className="h-5 w-5 mb-1" />
              <span className="text-xs font-semibold text-center leading-tight">Analysis</span>
            </button>
          </div>
        </div>
      </div>

    </div>
  );
};

export default MarketingBudgetReports;
